module.exports = __webpack_public_path__ + "img/icon-recycle@3x.377aba28.png";